import { ReactNode, memo } from "react"
import { MemberInfo } from "../../Member/MemberInfoV2"

import { useDateDistanceToNow } from "../../../hooks/useDateDistanceToNow"

type PostHeaderProps = {
  postId: string
  memberId: string
  memberName: string
  memberAvatar: string

  hideAction?: boolean
  rightSection?: ReactNode
}

export const PostHeader = memo((props: PostHeaderProps) => {
  const { postId, memberId, memberName, memberAvatar, rightSection } = props
  const { dateDistanceToNow } = useDateDistanceToNow()

  return (
    <MemberInfo>
      <MemberInfo.Avatar
        memberId={memberId}
        name={memberName}
        avatar={memberAvatar}
      />
      <MemberInfo.Content>
        <MemberInfo.Name memberId={memberId} name={memberName} />

        <MemberInfo.Description text={dateDistanceToNow(postId)} />
      </MemberInfo.Content>
      {rightSection}
    </MemberInfo>
  )
})
